'use strict';

var App = require('app');
var AppState = require('app_state');
var BaseFilterController = require('components/devices/controllers/base_filter_controller');
var FilterView = require('components/devices/views/filter/filter_view');
var HomeController = require('components/home/home_controller');
var Misc = require('utils/misc');

require('models/filter');

var FilterController = BaseFilterController.extend({
    showFilter: function (options, showResults) {
        var defaultFilter = {
            search_text: options.search_text,
        };
        _.each(['type', 'category', 'tags', 'groups', 'status', 'device_groups'], function (v) {
            defaultFilter[v] = options[v] || undefined;
        });

        if (defaultFilter.device_groups) {
            defaultFilter.device_groups = Misc.parseStrIntArray(defaultFilter.device_groups);
        }
        if (options.filter) {
            defaultFilter = options.filter;
        }

        this.page = options.page || 1;
        this.sortCol = options.sortCol || 'name';
        this.sortDesc = options.sortDesc || false;

        var self = this;
        HomeController.showBaseLayout({
            cb: function () {
                showResults = showResults || Backbone.history.fragment.indexOf('?') !== -1;
                self.filterView = new FilterView({
                    controller: self,
                    defaultFilter: defaultFilter,
                    showResults: showResults,
                    onFilterChangeDone: function (filter, isReload) {
                        // do not overwrite URL parameter on reload
                        var updateMode = isReload ? 'extend' : 'replace';
                        AppState.setURLParameter(Misc.filterToMap(filter), updateMode);
                    },
                });
                AppState.layout.breadcrumbs.reset();
                App.trigger('sidebar:default', 'search');
                App.showContentView(self.filterView);
            },
        });
    },

    getRequestParams: function () {
        var pagination = AppState.getURLParameter(['sortCol', 'sortDesc', 'page']);
        return {
            limit: this.getItemsPerPage(),
            page: pagination.page || this.page,
            sortDesc: pagination.sortDesc || this.sortDesc,
            sortCol: pagination.sortCol || this.sortCol,
        };
    },
});

module.exports = FilterController;
